module.exports = __webpack_public_path__ + "static/media/flipkart.9757b4c4.png";